<template>
    <v-dialog v-model="dialog" max-width="1020">
        <template #activator="{ on }">
            <v-btn v-on="on">Add Set of products</v-btn>
        </template>
        <v-card>
            <v-card-title>Add Set of products</v-card-title>
            <v-card-text>
                <v-form ref="setForm">
                    <v-row>
                        <v-col cols="6">
                            <v-text-field v-model="model.name" label="Name" @change="generateSku" :rules="[rules.required]"/>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="model.code" label="Code prefix" @change="generateSku" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="model.sku" label="SKU prefix" @change="generateSku" :rules="[rules.required]" />
                        </v-col>
                        <v-col cols="6">
                            <brand v-model="model.brand" label="Brand" :rules="[rules.required]"></brand>
                        </v-col>
                        <v-col cols="6">
                            <product-type v-model="model.type" label="Type" :rules="[rules.required]"></product-type>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="model.low_stock_limit" label="Low stock limit"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h2 class="subtitle-1">Set particles</h2>
                        </v-col>
                        <v-col cols="12" class="d-flex">
                            <v-checkbox
                                v-for="option in options[0]"
                                :key="option"
                                v-model="model.particles"
                                :label="option"
                                :value="option"
                                class="mr-2"
                            />
                        </v-col>
                        <v-col class="d-flex flex-wrap">
                            <v-checkbox
                                v-for="option in options[1]"
                                :key="option"
                                v-model="model.particles"
                                :label="option"
                                :value="option"
                                class="mr-2"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        
                    </v-row>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="subtitle-1">Catalogs and prices</h2>
                        </v-col>
                        <v-col cols="6" v-for="catalog in catalogs" v-bind:key="'_catalog_'+catalog.id">
                            <v-card >
                                <v-card-title>
                                    {{catalog.name}}
                                    <v-spacer />
                                    <v-btn color="white" @click="toggleToCatalog(catalog.id)">{{isInCatalog(catalog.id) ? 'Remove from catalog':'Add to catalog'}}</v-btn>
                                </v-card-title>
                                <v-card-text v-if="isInCatalog(catalog.id)">
                                    <v-row>
                                        <v-col v-for="currency in currencies" :key="'_curr_'+currency.id">
                                            <v-text-field v-model="productCatalog(catalog.id).prices[currency.currency]" :label="currency.currency"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
                <v-dialog v-model="alert" persistent max-width="600">
                    <v-sheet color="error">
                        <v-card-text class="white--text">
                            {{ errorMessage }}
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn @click="alert=false">Close</v-btn>
                        </v-card-actions>
                    </v-sheet>
                </v-dialog>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="cancel">Cancel</v-btn>
                <v-spacer />
                <v-btn @click="save">Create</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProductType from '../forms/autocomplete/ProductType.vue'
import Brand from "../forms/select/Brand.vue"
export default {
    components: { ProductType, Brand },
    data: () => ({
        dialog:false,
        errorMessage: null,
        alert: false,
        model: {
            catalogs: [],
            particles: []
        },
        options: [
            ['3I', '4I', '5I', '6I', '7I', '8I', '9I', '10I', '11I', 'AW', 'GW', 'LW', 'PW', 'SW', 'UW'],
            ['35.5','36', '36.5', '37', '37.5', '38', '38.5', '39', '39.5', '40', '44', '46', '50', '56', '60'],
        ],
        
    }),

    computed: {
        ...mapGetters("catalogs",["catalogs"]),
        ...mapGetters("currencies",["currencies"]),
        rules: function() {
            return {
                required: value => !!value || "This field is mandatory.",
            };
        },
        productCatalog:function(){
            return (catalogId) => this.model.catalogs.find(c => c.catalog_id == catalogId)
        }
    },
    methods: {
        ...mapActions('products', ['createSet']),
        save () {
            if(!this.$refs.setForm.validate()){
                alert('bad')
                return false
            }

            this.createSet(this.model)
                .then(({ set }) => {
                    this.$router.push("/sets/view/" + set.id);
                })
                .catch((response) => {
                    this.alert = true
                    this.errorMessage = response.message
                })
        },

        cancel () {
            this.$refs.setForm.reset()
            this.dialog = false
        },

        generateSku(){
            if(!this.model.sku){
                let sku = this.model.name;
                sku = sku.toUpperCase();
                sku = sku.replace(/\s/g,'')
                this.model.sku = sku
            }
        },

        isInCatalog(catalogId){
            return this.model.catalogs.find(c => c.catalog_id== catalogId)
        },

        toggleToCatalog(catalogId){
            if(this.isInCatalog(catalogId)){
                this.model.catalogs = this.model.catalogs.filter(c => c.catalog_id != catalogId)
            }else{
                this.model.catalogs.push({catalog_id:catalogId, prices:{}})
            }
        },
    }
}
</script>